import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import moment from 'moment-timezone'
import Divider from '@material-ui/core/Divider'
import Hidden from '@material-ui/core/Hidden'
import LeftFormComponent from './LeftFormComponent'
import RightFormComponent from './RightFormComponent'
import validate from './ValidationHelpers'
function checkComplete(requiredConfig, config = {}) {
  let isComplete = true
  Object.keys(requiredConfig).map(name => {
    isComplete =
      !validate(name, config[name]).isValid && isComplete === true
        ? false
        : isComplete
    return null
  })
  return isComplete
}
const styles = theme => ({
  root: {
    flexGrow: 1
  },
  gridContainer: {
    padding: 10
  },
  backButton: {
    marginRight: theme.spacing.unit
  }
})
const defaultConf = {
  timeZone: '',
  companyName: '',
  country: '',
  currency: '',
  adresse: '',
  cp: '',
  city: '',
  phone: ''
}
export default withStyles(styles)(
  class GeneralInformationsStepComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      step: PropTypes.object.isRequired,
      auth: PropTypes.object.isRequired,
      config: PropTypes.object.isRequired,
      goToNext: PropTypes.func.isRequired,
      completed: PropTypes.func.isRequired,
      onChange: PropTypes.func.isRequired
    }
    static defaultProps = {
      config: defaultConf
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.config) {
        if (
          checkComplete(defaultConf, nextProps.config) &&
          !nextProps.step.complete
        ) {
          this.props.completed(true)
        } else if (
          !checkComplete(defaultConf, nextProps.config) &&
          nextProps.step.complete
        ) {
          this.props.completed(false)
        }
        if (!nextProps.config.timeZone) {
          this.props.onChange('timeZone', moment.tz.guess())
        }
      }
    }
    componentWillMount() {
      const { config, step } = this.props
      if (config) {
        if (checkComplete(defaultConf, config) && !step.isCompleted) {
          this.props.completed(true)
        } else if (!checkComplete(defaultConf, config) && step.isCompleted) {
          this.props.completed(false)
        }
        if (!config.timeZone) {
          this.props.onChange('timeZone', moment.tz.guess())
        }
      }
    }

    handleNextStep() {
      this.props.goToNext()
    }
    handleOnChange = (name, value) => {
      this.props.onChange(name, value)
    }

    renderLeftSide() {
      const { auth, config } = this.props
      const { email, firstName, lastName } = auth
      const { timeZone, currency, country } = config

      return (
        <LeftFormComponent
          handleChange={this.handleOnChange}
          email={email}
          lastName={lastName || ''}
          firstName={firstName || ''}
          timeZone={timeZone || ''}
          currency={currency || ''}
          country={country || ''}
        />
      )
    }
    renderRightSide() {
      const {
        companyName,
        adresse,
        cp,
        city,
        phone,
        country
      } = this.props.config
      return (
        <RightFormComponent
          handleChange={this.handleOnChange}
          companyName={companyName}
          adresse={adresse}
          cp={cp}
          city={city}
          country={country}
          phone={phone}
        />
      )
    }
    render() {
      const { classes } = this.props
      return (
        <Grid container className={classes.root}>
          <Grid item xs={12}>
            <Grid
              container
              className={classes.gridContainer}
              alignItems="flex-start"
              direction="row"
              justify="center">
              <Grid item xs={12} md={6}>
                {this.renderLeftSide()}
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Hidden>
              <Grid item xs={12} md={6}>
                {this.renderRightSide()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/GeneralInformations/GeneralInformationsStepComponent.js